import { render, staticRenderFns } from "./EditPostModal.vue?vue&type=template&id=24a8a7a7&scoped=true"
import script from "./EditPostModal.vue?vue&type=script&lang=js"
export * from "./EditPostModal.vue?vue&type=script&lang=js"
import style0 from "./EditPostModal.vue?vue&type=style&index=0&id=24a8a7a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a8a7a7",
  null
  
)

export default component.exports